import React, { useState } from 'react';
import './AccessibilityStatement.css';
import Navbar from '../components/Navbar';
import TopInfoBar from '../components/TopInfoBar';
import BookingSidebar from '../components/BookingSidebar';
import Footer from '../components/Footer';

function AccessibilityStatement() {
  const [isBookingOpen, setIsBookingOpen] = useState(false);

  const handleOpenBooking = () => setIsBookingOpen(true);
  const handleCloseBooking = () => setIsBookingOpen(false);

  return (
    <div className="accessibility-statement-page">
      <TopInfoBar />
      <Navbar onBookNowClick={handleOpenBooking} />
      <section className="accessibility-statement-section">
        <div className="accessibility-statement-container">
          <div className="accessibility-statement-content">
            <h1 className="accessibility-statement-title">Accessibility Statement</h1>
            <p className="accessibility-statement-intro">
              Hacienda Del Sol Resort is committed to providing an accessible website experience for all guests, including people with disabilities. We strive to ensure our website is usable and navigable for everyone.
            </p>

            <div className="accessibility-section">
              <h2 className="accessibility-section-title">Accessibility Features:</h2>
              <ul className="accessibility-list">
                <li>Text is structured for readability and clarity</li>
                <li>Forms are labeled clearly for screen readers</li>
                <li>Images include descriptive alt text where appropriate</li>
                <li>Our website is designed to be navigable using a keyboard</li>
              </ul>
            </div>

            <div className="accessibility-section">
              <h2 className="accessibility-section-title">Limitations:</h2>
              <p className="accessibility-section-text">
                While we aim to make our website fully accessible, some content or features may not yet meet all accessibility standards. We are continuously working to improve accessibility and welcome feedback.
              </p>
            </div>

            <div className="accessibility-section">
              <h2 className="accessibility-section-title">Feedback and Assistance:</h2>
              <p className="accessibility-section-text">
                If you encounter accessibility barriers or need assistance accessing our content, please contact us:
              </p>
              <ul className="accessibility-list">
                <li>Phone: [956] 459-9800</li>
              </ul>
              <p className="accessibility-section-text">
                We will make every effort to provide the information or service you need in an accessible format.
              </p>
            </div>

            <div className="accessibility-section">
              <p className="accessibility-effective-date">
                Effective Date: [01/08/2026]
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer onBookNowClick={handleOpenBooking} />
      <BookingSidebar isOpen={isBookingOpen} onClose={handleCloseBooking} />
    </div>
  );
}

export default AccessibilityStatement;
